document.addEventListener('DOMContentLoaded', function () {
    initializeMobileMenu();

    function initializeMobileMenu() {
        const offCanvasBtn = document.getElementById('off-canvas-btn');
        const mobileMenu = document.getElementById('mobile-menu');
        const mobileMenuClose = document.getElementById('mobile-menu-close');
        const menuLinks = document.querySelectorAll('#mobile-menu-nav a');

        if (!offCanvasBtn || !mobileMenu || !mobileMenuClose) {
            return;
        }

        function openMenu() {
            mobileMenu.classList.add('open-menu');
        }

        function closeMenu() {
            mobileMenu.classList.remove('open-menu');
        }

        offCanvasBtn.addEventListener('click', openMenu);
        mobileMenuClose.addEventListener('click', closeMenu);

        // Close menu when clicking on links
        menuLinks.forEach(link => {
            link.addEventListener('click', closeMenu);
        });

        // Close menu when clicking outside its area
        window.addEventListener('click', function(event) {
            if (!mobileMenu.contains(event.target) && !offCanvasBtn.contains(event.target)) {
                closeMenu();
            }
        });
    }
});

jQuery(document).ready(function ($) {
    $('#navzleto-contact-form').on('submit', function (e) {
        e.preventDefault();
        $('#navzleto-popup-thank-you').fadeIn(300);

        setTimeout(function () {
            $('#navzleto-popup-thank-you').fadeOut(300);
        }, 3000);

        $('#navzleto-contact-form')[0].reset();
    });

    $('#navzleto-contact-form-two').on('submit', function (e) {
        e.preventDefault();
        $('#navzleto-popup-thank-you-two').fadeIn(300);

        setTimeout(function () {
            $('#navzleto-popup-thank-you-two').fadeOut(300);
        }, 3000);

        $('#navzleto-contact-form-two')[0].reset();
    });

    $('#navzleto-subscribe').on('submit', function (e) {
        e.preventDefault();
        $('#navzleto-popup-thank-you-subscribe').fadeIn(300);

        setTimeout(function () {
            $('#navzleto-popup-thank-you-subscribe').fadeOut(300);
        }, 3000);

        $('#navzleto-subscribe')[0].reset();
    });
});